module.exports = __webpack_public_path__ + "img/img35.ae016e34.svg";